<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="25"
    viewBox="0 0 750 471"
    :width="width"
  >
    <g fill="none">
      <rect fill="#00425f" height="471" rx="40" width="750" />
      <circle cx="156.26347" cy="215.5" fill="#ee312a" r="115.26347" />
      <g fill="#fff">
        <path
          d="m156.26347 264.87251c-25.77978-58.44077-44.6849-113.0323-44.6849-113.0323h-39.52473s24.05687 70.07163 68.74177 157.70044h30.93573c44.6849-87.62881 68.74177-157.70044 68.74177-157.70044h-39.52474s-18.90512 54.59153-44.6849 113.0323z"
        />
        <path
          d="m708.04515 257.60566h-77.32874s1.718 25.78124 36.08666 25.78124c17.18378 0 34.36885-5.16013 34.36885-5.16013l3.43733 27.4942s-17.18507 6.87394-41.24337 6.87394c-34.36743 0-65.299-17.1845-65.299-65.29966 0-37.80547 24.05687-61.86305 58.42572-61.86305 51.55255 0 54.98988 51.55249 51.55255 72.17346zm-53.27044-48.11588c-22.34035 0-24.0583 24.05758-24.0583 24.05758h48.11517s-1.71795-24.05758-24.05687-24.05758z"
        />
        <path
          d="m442.3337 216.74823 5.15514-27.49491s-39.81248-12.0813-72.17346 10.31056v109.97679h34.37014l-.00271-89.35582c13.74644-10.31042 32.65089-3.43662 32.65089-3.43662z"
        />
        <path
          d="m348.41613 257.60566h-77.32874s1.718 25.78124 36.08666 25.78124c17.18378 0 34.36743-5.16013 34.36743-5.16013l3.43733 27.4942s-17.18364 6.87394-41.24194 6.87394c-34.36885 0-65.30038-17.1845-65.30038-65.29966 0-37.80547 24.0583-61.86305 58.42715-61.86305 51.55249 0 54.98836 51.55249 51.55249 72.17346zm-53.27187-48.11588c-22.33892 0-24.05687 24.05758-24.05687 24.05758h48.11517s-1.71796-24.05758-24.0583-24.05758z"
        />
        <path
          d="m525.80355 268.32373c-10.68307-25.981877-19.301841-52.7653-25.77626-80.1015l-34.366.00454s17.18371 66.34494 46.39864 121.31943h27.48724c29.21495-54.97449 46.39864-121.3072 46.39864-121.3072h-34.366c-6.475853 27.330341-15.0946 54.10808-25.77626 80.08473z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: ["width"],
};
</script>

<style lang="scss" scoped></style>
